module.exports = __webpack_public_path__ + "static/img/doc.248dbda4.png";